module.exports = __webpack_public_path__ + "fa5630a44baa2ec9745f65e7a03e24c0.jpg";